import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
app.initializers.add('val-ui-mobile-badges-menu', () => {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    const user = app.session.user;
    const isAdmin = !!(user && user.isAdmin && user.isAdmin());
    const canModerate = isAdmin || !!app.forum.attribute('canAccessValModeration');
    if (app.forum.attribute('canViewBadges')) {
      items.add('valMobileBadges', m(LinkButton, {
        href: app.route('badges'),
        icon: "fas fa-award",
        className: "Button Button--link val-mobile-badges-nav"
      }, app.translator.trans('fof-badges.forum.nav.badges')), 15);
    }
    if (canModerate) {
      items.add('valMobileModeration', m(LinkButton, {
        href: app.route('val-moderation'),
        icon: "fas fa-shield-alt",
        className: "Button Button--link val-mobile-moderation-nav"
      }, "Mod\xE9ration"), 14);
    }
    if (isAdmin) {
      items.add('valMobileAdmin', m(LinkButton, {
        href: "/admin",
        external: true,
        icon: "fas fa-cog",
        className: "Button Button--link val-mobile-admin-nav"
      }, "Administration"), 13);
    }
  });
});